module.exports = __webpack_public_path__ + "static/img/11.4886a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/11.jpg
// module id = Yb2M
// module chunks = 1